import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EmailProviderConfigRequest, EmailProviderConfigResponse } from '../models/email-config.model';

@Injectable({
  providedIn: 'root'
})
export class EmailConfigApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}api`;

  getGlobalConfig(): Observable<EmailProviderConfigResponse> {
    return this.http.get<EmailProviderConfigResponse>(`${this.apiUrl}/admin/email-config/global`);
  }

  createOrReplaceGlobal(request: EmailProviderConfigRequest): Observable<EmailProviderConfigResponse> {
    return this.http.post<EmailProviderConfigResponse>(`${this.apiUrl}/admin/email-config/global`, request);
  }

  updateGlobal(request: EmailProviderConfigRequest): Observable<EmailProviderConfigResponse> {
    return this.http.put<EmailProviderConfigResponse>(`${this.apiUrl}/admin/email-config/global`, request);
  }

  deactivateGlobal(): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/admin/email-config/global`);
  }

  sendTestEmail(to?: string): Observable<void> {
    const url = to ? `${this.apiUrl}/admin/email-config/global/test?to=${encodeURIComponent(to)}` : `${this.apiUrl}/admin/email-config/global/test`;
    return this.http.post<void>(url, {});
  }
}